export function headerLoginWindow(): void {
  const loginWindow = document.getElementById('js-header-login-window')
  const loginTrigger = document.getElementById('js-login-toggle')
  const hideClassName = 'is-hide'

  if (loginWindow === null || loginTrigger === null) return

  loginTrigger.addEventListener('click', () => {
    loginWindow.classList.toggle(hideClassName)
  })
  loginWindow.addEventListener('click', (e) => {
    e.stopPropagation()
  })
  document.addEventListener('click', (e) => {
    if (e.target === loginTrigger || loginWindow.classList.contains(hideClassName)) return
    loginWindow.classList.add(hideClassName)
  })
}
